enum WageRate {
  HOURLY = 10,
  WEEKLY = 30,
  MONTHLY = 40,
  YEARLY = 50,
}

export default WageRate;
